function formatLocalIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function getIsoDobMaxForMinAge(
  minAgeYears: number,
  fromDate: Date = new Date()
): string {
  const d = new Date(fromDate);
  d.setHours(0, 0, 0, 0);
  d.setFullYear(d.getFullYear() - minAgeYears);
  return formatLocalIsoDate(d);
}

export function getIsoDobMinForMaxAge(
  maxAgeYears: number,
  fromDate: Date = new Date()
): string {
  const d = new Date(fromDate);
  d.setHours(0, 0, 0, 0);
  d.setFullYear(d.getFullYear() - maxAgeYears);
  return formatLocalIsoDate(d);
}

const MEMBER_MIN_AGE = 18;
const MEMBER_MAX_AGE = 120;

export function getMemberDobHtmlInputBounds(fromDate: Date = new Date()) {
  return {
    min: getIsoDobMinForMaxAge(MEMBER_MAX_AGE, fromDate),
    max: getIsoDobMaxForMinAge(MEMBER_MIN_AGE, fromDate)
  };
}

export function validateMemberDobMinAge(
  value: string | undefined,
  fromDate: Date = new Date()
): string | undefined {
  if (!value?.trim()) {
    return undefined;
  }
  const parts = value.split("-");
  if (parts.length !== 3) {
    return "Enter a valid date of birth";
  }
  const y = Number.parseInt(parts[0], 10);
  const mo = Number.parseInt(parts[1], 10) - 1;
  const day = Number.parseInt(parts[2], 10);
  if (
    Number.isNaN(y) ||
    Number.isNaN(mo) ||
    Number.isNaN(day) ||
    mo < 0 ||
    mo > 11
  ) {
    return "Enter a valid date of birth";
  }
  const birth = new Date(y, mo, day);
  birth.setHours(0, 0, 0, 0);
  if (
    birth.getFullYear() !== y ||
    birth.getMonth() !== mo ||
    birth.getDate() !== day
  ) {
    return "Enter a valid date of birth";
  }

  const maxBirth = new Date(fromDate);
  maxBirth.setHours(0, 0, 0, 0);
  maxBirth.setFullYear(maxBirth.getFullYear() - MEMBER_MIN_AGE);
  if (birth.getTime() > maxBirth.getTime()) {
    return `You must be at least ${MEMBER_MIN_AGE} years old`;
  }

  const minBirth = new Date(fromDate);
  minBirth.setHours(0, 0, 0, 0);
  minBirth.setFullYear(minBirth.getFullYear() - MEMBER_MAX_AGE);
  if (birth.getTime() < minBirth.getTime()) {
    return "Please enter a valid date of birth";
  }

  return undefined;
}
